import React, { useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";


const NavItemMobile = props => {
  const {activeFilters} = useContext(Context);
  const {widget, toggleFilterNav} = props;

  let filter_count = 0;

  if (typeof widget.filters != "undefined"){
    filter_count = activeFilters[widget.filters[0].name].value.length;
  }
  if (widget.type == "search" && filter_count > 0){
    filter_count = 1;
  }

  return (
    <>
    <div
      className={classnames('filter-nav-item-mobile font-title ', {
        open: widget.open
      })}
      onClick={() => toggleFilterNav(widget)}
    >
      {widget.title}
      <span aria-hidden="true" className="sr-only"> (</span>
      <span
      className={classnames('filter-count', {
        active: filter_count > 0
      })}>{filter_count}</span>
      <span className="sr-only" aria-hidden="true"> filters selected)</span>
    </div>
    </>
  )
}

export default NavItemMobile;
